const msgs = {
  'not-enough-data': 'Not enough data',
  'unknown-error': 'Unknown error',
  'not-permissions': "You don't have enough permissions for this action",

  'login-field-empty':  'Please enter your login!',
  'login-field-no-email': 'Your login should be an email!',
  'password-field-empty': 'Please enter your password!',
  'password-field-too-short': 'Your password is too short!',
  'token-empty': 'You looks like a robot!',
  'empty-recaptcha': 'Faild to generate ReCaptcha',

  'signin-failed': 'Signing in failed',
  'signin-wrong-data': 'Invalid username or password',
  'signout-failed': 'Signing out failed',

  'load-orders-filed': 'Failed to load orders',
  'order-load-failed': 'Failed to load the order',
  'empty-order-id': 'Order not found',
};

export const msg = (key: keyof typeof msgs, options?: Record<string, string | number>): string =>
  options
    ? Object.entries(options).reduce((acc, [key, value]) =>
      acc.replaceAll(`{{${key}}}`, String(value)), msgs[key])
    : msgs[key];
